module.exports = __webpack_public_path__ + "static/light-gradient-2-mobile-506d43fb06fcb991409138f7446d896c.png";